import { render, staticRenderFns } from "./EntryGameCard.vue?vue&type=template&id=9c7dbc04&"
import script from "./EntryGameCard.vue?vue&type=script&lang=js&"
export * from "./EntryGameCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports